import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store/index'
import basics from './core/basics'

import './core/use'
import './components/global.less'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created: basics,
  render: h => h(App),
}).$mount('#app')
